import { useQuery } from '@tanstack/react-query'
import { schemasApi } from '@/services/api/schemas'

export const caseSchemaStatusKey = (caseId: string) => ['case', caseId, 'schemas'] as const

export type CaseSchemaStatus = 'loading' | 'error' | 'required' | 'ready'

/** A shared global fallback or unaccepted draft does not complete case preparation. */
export function useCaseSchemaStatus(caseId: string | undefined) {
  const query = useQuery({
    queryKey: caseSchemaStatusKey(caseId ?? ''),
    queryFn: () => schemasApi.listForCase(caseId!),
    enabled: !!caseId,
    staleTime: 30_000,
  })
  const hasSchema =
    query.data?.some(schema => schema.case_id === caseId && schema.version > 0) ?? false
  const status: CaseSchemaStatus = query.isError
    ? 'error'
    : query.isPending
      ? 'loading'
      : hasSchema
        ? 'ready'
        : 'required'
  return {
    status,
    hasSchema,
    needsSchema: query.isSuccess && !hasSchema,
    isError: query.isError,
    isLoading: query.isPending,
    refetch: query.refetch,
  }
}
